export type TSize = '1/4' | '1/2' | '3/4' | '1';

export interface IAllowedSizes {
  /**
   * Set an explicit, proportional size
   */
  sizePreset?: TSize;
}

/**
 * A list of official sizes for supported inputs, designated by fraction
 */
export const allowedSizes: { [size in TSize]: string } = {
  /* tslint:disable:object-literal-sort-keys */
  '1/4': '25%',
  '1/2': '50%',
  '3/4': '75%',
  '1': '100%'
  /* tslint:enable:object-literal-sort-keys */
};

/**
 * Turn strings representing fractions into numbers, in case you need to sort
 * them or, you know, whatever
 * @param fraction A fraction string like '1/4'
 */
export function fractionToNumber(fraction: string): number {
  const parts = fraction.split('/');
  if (parts.length === 1) {
    return Number(parts[0]);
  } else {
    return Number(parts[0]) / Number(parts[1]);
  }
}

export function sizeStyles(sizePreset: any) {
  const tagStyles: {
    maxWidth?: number | string;
  } = {};

  if (sizePreset) {
    const sizeWidth = allowedSizes[sizePreset as TSize];
    if (sizeWidth) {
      tagStyles.maxWidth = sizeWidth;
    }
  }

  return tagStyles;
}